const withPrefix = (value, prefix) => {
  if (Array.isArray(value)) {
    return value.map((item) => withPrefix(item, prefix))
  }
  if (typeof value !== 'string') return value
  if (value.startsWith('http://') || value.startsWith('https://')) return value
  if (value.startsWith(`${prefix}/`)) return value
  return `${prefix}/${value}`
}

const VENDOR_ENDPOINTS = {
  LOGIN_VENDOR: 'login_vendor',
  REGISTER_VENDOR: 'register_vendor',
  LOGIN_RESET: 'login_reset',
  LOGIN_RESET_VERIFY: 'login_reset_verify',
  FORGOT_PASSWORD_CANDIDATES: ['login_reset', 'forgot_password', 'reset_password'],
  FORGOT_PASSWORD_VERIFY_CANDIDATES: ['login_reset_verify', 'forgot_password_verify', 'reset_password_verify'],
  GET_PROFILE_VENDOR: 'get_profile_vendor',
  UPDATE_PROFILE_VENDOR_CANDIDATES: ['update_profile_vendor', 'edit_profile_vendor', 'edit_profile'],
  CHANGE_PASSWORD_VENDOR_CANDIDATES: ['changepwd', 'change_password_vendor', 'change_password'],
  LIST_BUSINESS_VENDOR: 'list_business_vendor',
  ADD_BUSINESS_VENDOR: 'add_business_vendor',
  EDIT_BUSINESS_VENDOR: 'edit_business_vendor',
  UPDATE_BUSINESS_VENDOR: 'update_business_vendor',
  UPDATE_BUSINESS_CONTACT_VENDOR: 'update_business_contact_vendor',
  UPDATE_BUSINESS_DOCUMENTS_VENDOR: 'update_business_documents_vendor',
  DELETE_BUSINESS_DOCUMENTS_VENDOR: 'delete_business_documents_vendor',
  UPDATE_BUSINESS_NOTIFICATIONS_VENDOR: 'update_business_notifications_vendor',
  ADD_BUSINESS_VENDOR_CONTACT: 'add_business_vendor_contact',
  GET_BUSINESS_VENDOR_CONTACT: 'get_business_vendor_contact',
  UPDATE_BUSINESS_VENDOR_CONTACT: 'update_business_vendor_contact',
  DELETE_BUSINESS_VENDOR_CONTACT: 'delete_business_vendor_contact',
  UPDATE_BUSINESS_BANK_VENDOR: 'update_business_bank_vendor',
  DELETE_BUSINESS_VENDOR: 'delete_business_vendor',
  ADD_VENDOR_BUSINESS_VENUE: 'add_vendor_business_venue',
  GET_VENUE_HIGHLIGHTS: 'get_venue_highlights',
  GET_VENUE_TYPES: 'get_venue_types',
  GET_VENUE_EVENTS_HOSTED: 'get_venue_events_hosted',
  GET_VENUE_AMENITIES: 'get_venue_amenities',
  GET_VENUE_INHOUSE_SERVICES: 'get_venue_inhouse_services',
  GET_VENUE_FACILITY_DETAILS: 'get_venue_facility_details',
  GET_SERVICE_VENDOR_CATEGORIES: 'get_service_vendor_categories',
  ADD_SERVICE_VENDOR: 'add_service_vendor',
  UPDATE_SERVICE_VENDOR: 'update_service_vendor',
  DELETE_SERVICE_VENDOR: 'delete_service_vendor',
  LIST_SERVICE_VENDORS: 'list_service_vendors',
  LIST_SERVICE_CATALOG_THEMES: 'list_service_catalog_themes',
  LIST_SERVICE_CATALOG_STYLES: 'list_service_catalog_styles',
  LIST_SERVICE_CATALOG_FIELDS: 'list_service_catalog_fields',
  UPDATE_SERVICE_VENDOR_META_DETAILS: 'update_service_vendor_meta_details',
  GET_SERVICE_VENDOR_META_DETAILS: 'get_service_vendor_meta_details',
  GET_SERVICE_VENDOR_POLICY_DETAILS: 'get_service_vendor_policy_details',
  UPDATE_SERVICE_VENDOR_POLICY_DETAILS: 'update_service_vendor_policy_details',
  ADD_SERVICE_VENDOR_GALLERY: 'add_service_vendor_gallery',
  GET_SERVICE_VENDOR_GALLERY: 'get_service_vendor_gallery',
  DELETE_SERVICE_VENDOR_GALLERY: 'delete_service_vendor_gallery',
  UPDATE_SERVICE_VENDOR_COVER_IMAGE: 'update_service_vendor_cover_image',
  EDIT_SERVICE_CATALOG_VENDOR: 'edit_service_catalog_vendor',
  ADD_SERVICE_CATALOG_VENDOR: 'add_service_catalog_vendor',
  ADD_SERVICE_CATALOG_SERVICE_VENDOR: 'add_service_catalog_service_vendor',
  LIST_SERVICE_CATALOG_SERVICE_VENDOR: 'list_service_catalog_service_vendor',
  PUBLISH_SERVICE_VENDOR_DETAILS: 'publish_service_vendor_details',
  LIST_VENUES_BUSINESS_VENDOR: 'list_venues_business_vendor',
  UPDATE_VENDOR_VENUE_DETAILS: 'update_vendor_venue_details',
  PUBLISH_VENDOR_VENUE_DETAILS: 'publish_vendor_venue_details',
  ADD_PACKAGE_VENUE: 'add_package_venue',
  UPDATE_PACKAGE_VENUE: 'update_package_venue',
  EDIT_PACKAGE_VENUE: 'edit_package_venue',
  GET_PACKAGES_VENUE: 'get_packages_venue',
  DELETE_PACKAGE_VENUE: 'delete_package_venue',
  ADD_POLICIES_VENUE: 'add_policies_venue',
  EDIT_POLICIES_VENUE: 'edit_policies_venue',
  ADD_VENUE_VENDOR_PARTNER: 'add_venue_vendor_partner',
  UPDATE_VENUE_VENDOR_PARTNER: 'update_venue_vendor_partner',
  LIST_VENUE_VENDOR_PARTNERS: 'list_venue_vendor_partners',
  DELETE_VENUE_VENDOR_PARTNER: 'delete_venue_vendor_partner',
  GET_VENUE_GALLERY_CATEGORIES: 'get_venue_gallery_categories',
  GET_VENUE_GALLERY: 'get_venue_gallery',
  ADD_VENUE_GALLERY: 'add_venue_gallery',
  DELETE_VENUE_GALLERY: 'delete_venue_gallery',
  UPDATE_VENUE_COVER_IMAGE: 'update_venue_cover_image',
  GET_VENUE_META_DETAILS: 'get_venue_meta_details',
  UPDATE_VENUE_META_DETAILS: 'update_venue_meta_details',
  GET_VENUE_AVAILABILITY: 'get_venue_availability',
  UPDATE_AVAILABILITY_VENUE: 'update_availability_venue',
  GET_ENQUIRIES: 'get_enquiries',
  UPDATE_NOTES_ENQUIRY: 'update_notes_enquiry',
  GET_SPACE_GALLERY: 'get_space_gallery',
  ADD_SPACE_GALLERY: 'add_space_gallery',
  GET_VENUE_SPACE_TYPES: 'get_venue_space_types',
  GET_VENUE_SPACE_SEAT_CONFIG: 'get_venue_space_seat_config',
  ADD_VENUE_SPACE: 'add_venue_space',
  UPDATE_VENUE_SPACE: 'update_venue_space',
  DELETE_VENUE_SPACE: 'delete_space_venue',
  LIST_VENUE_SPACES: 'list_venue_spaces',
  ADD_VENUE: 'add_venue',
  UPDATE_VENUE: 'update_venue',
  DELETE_VENUE: 'delete_venue',
  LIST_VENDOR_PACKAGES: 'list_vendor_packages',
  ADD_VENDOR_PACKAGE: 'add_vendor_package',
  DELETE_VENDOR_PACKAGE: 'delete_vendor_package',
  UPDATE_VENDOR_PACKAGE: 'update_vendor_package',
  GET_SUBCATEGORIES: 'get_subcategories'
}

Object.keys(VENDOR_ENDPOINTS).forEach((key) => {
  VENDOR_ENDPOINTS[key] = withPrefix(VENDOR_ENDPOINTS[key], 'api_s')
})

export default VENDOR_ENDPOINTS
